module.exports = __webpack_public_path__ + "static/media/404-question.b95710b9.svg";